export default __webpack_public_path__ + "static/media/shape2.2d8594e6.svg";